export default {
  // Doesn't use await due to babel-related regenerator issues
  getCart () {
    return fetch('/cart.js')
      .then(response => response.json())
      .catch(console.error)
  },

  // Alert other scripts of a new cart state
  cartUpdated (cart = null) {
    if (cart) {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }))
    } else {
      this.getCart()
        .then((cart) => {
          document.dispatchEvent(
            new CustomEvent('cart:updated', { detail: cart })
          )
        })
        .catch(console.error)
    }
  },

  // Get info about product using product handle
  getProduct (productHandle) {
    return new Promise((resolve, reject) => {
      fetch(`/products/${productHandle}.js`)
        .then((response) => {
          // console.log('Product info response:', response)
          return response.json()
        })
        .then((data) => {
          // console.log('Product info data:', data)
          resolve(data)
        })
        .catch((err) => {
          console.error('get product info error:', err)
          reject(err)
        })
    })
  },

  // Add main shopify product and any recommended accessories to cart using ajax POST API
  addProductsToCart (
    products = [{ id: 0, quantity: 1 }],
    openSlideOutCart = true,
    reload = false
  ) {
    this.disableAddToCart()

    return new Promise((resolve, reject) => {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: products
        })
      })
        .then((response) => {
          // console.log('Add to cart data response:', response)
          return response.json()
        })
        .then((data) => {
          // console.log('Add to cart data resolve:', data)

          /* Original from DS plus price adjustments
          // For Tombras: modify Shopify prices to be /100 and add product data to dataLayer before sending to GTM
          const newData = data
          newData.items.forEach((item) => {
            // price fields in data: discounted_price, final_line_price, final_price, original_price, original_line_price, price, line_price
            item.price = item.price / 100
            item.discounted_price = item.discounted_price / 100
            item.final_price = item.final_price / 100
            item.final_line_price = item.final_line_price / 100
            item.line_price = item.line_price / 100
            item.original_price = item.original_price / 100
            item.original_line_price = item.original_line_price / 100
          })
          window.dataLayer.push({ ecommerce: newData })
          window.dataLayer.push({ event: 'AddtoCart' })
          */

          // new per Tombras for setting up data structure according to https://developers.google.com/analytics/devguides/collection/ua/gtm/enhanced-ecommerce#cart
          const newData = {
            currencyCode: 'USD',
            add: {
              products: []
            }
          }

          data.items.forEach((item) => {
            newData.add.products.push({
              id: item.id,
              name: item.title,
              price: item.price / 100,
              brand: item.vendor,
              category: item.product_type,
              variant: item.variant_title,
              quantity: item.quantity
            })
          })

          // clear previous object
          window.dataLayer.push({ ecommerce: null })
          window.dataLayer.push({
            event: 'addToCart',
            ecommerce: newData
          })

          /* back to original code */

          // Show cart slide out
          if (openSlideOutCart) {
            document.dispatchEvent(new CustomEvent('cart:show'))
          }

          // Re-enable button
          this.enableAddToCart()

          // Tell places like the slide out cart to update their view
          this.cartUpdated()

          if (reload) {
            location.reload()
          }

          resolve()
        })
        .catch((err) => {
          console.error('Add to cart error:', err)

          // Re-enable button
          this.enableAddToCart()

          reject(err)
        })
    })
  },

  getDefaultVariantID (container = 'section.product-section') {
    return this.getProductData(container, 'data-default-variant-id')
  },

  getProductHandle (container = 'section.product-section') {
    return this.getProductData(container, 'data-product-handle')
  },

  getDefaultVariantPrice (container = 'section.product-section') {
    return this.getProductData(container, 'data-default-variant-price')
  },

  getDefaultVariantComparePrice (container = 'section.product-section') {
    const comparePrice = this.getProductData(
      container,
      'data-default-variant-compare-price'
    )
    return comparePrice || 0
  },

  getGiftCardStatus (container = 'section.product-section') {
    return this.getProductData(container, 'data-gift-card')
  },

  getProductData (container = 'section.product-section', prop) {
    const elem = document.querySelector(`${container} [${prop}]`)
    return elem ? elem.getAttribute(prop) : null
  },

  // Disable add to cart button while request is sending
  disableAddToCart (
    message = 'ADDING TO CART..',
    container = 'section.product-section',
    ref = 'addToCartButton'
  ) {
    this.setAddToCartState(true, container, ref, message)
  },

  // Enable add to cart button after request is sent
  enableAddToCart (
    container = 'section.product-section',
    ref = 'addToCartButton'
  ) {
    this.setAddToCartState(false, container, ref, 'ADD TO CART')
  },

  // Look for addToCartButtons inside container selector
  setAddToCartState (
    disabled,
    container = 'section.product-section',
    message = 'ADD TO CART',
    ref = 'addToCartButton'
  ) {
    // NOTE: Not using $refs since ALL add to cart buttons are wanted
    // Specify section.product-section to avoid mini product cards with add-to-cart buttons
    document
      .querySelectorAll(`${container} [ref="${ref}"]`)
      .forEach((button) => {
        const innerElem =
          button.children.length > 0 ? button.children[0] : button
        button.disabled = disabled
        innerElem.innerText = message
      })
  }
}
